import { render, staticRenderFns } from "./Billable.vue?vue&type=template&id=b3b65874&scoped=true"
import script from "./Billable.vue?vue&type=script&lang=js"
export * from "./Billable.vue?vue&type=script&lang=js"
import style0 from "./Billable.vue?vue&type=style&index=0&id=b3b65874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b65874",
  null
  
)

export default component.exports